export enum BrazeEvents {
  MediaRequestViewedByTalent = 'media_request_viewed_talent',
  OpenCallInitialRegistrationComplete = 'open_call_initial_registration_complete',
  OpenCallRegistrationComplete = 'open_call_registration_complete',
  PCEmailVerificationComplete = 'pc_email_verification_complete',
  PCProfileCreationComplete = 'pc_profile_creation_complete',
  PCRegistrationPageComplete = 'pc_registration_page_complete',
  ProfileCreationComplete = 'profile_creation_complete',
  PushPrimer = 'prime-for-push',
  RegistrationPageComplete = 'registration_page_complete',
  SavedSearchCreated = 'saved_search_created',
  SavedSearchNotificationOptIn = 'saved_search_notification_optin',
  TalentScoutSaveButton = 'talent_scout_save_button',
  TalentTapsGlobalUpgradeButton = 'talent_taps_global_upgrade_button',
  UploadedAudio = 'uploaded_audio',
  UploadedPhoto = 'uploaded_photo',
  UploadedVideo = 'uploaded_video',
  CardlessPurchase = 'cardless_purchase',
  CardlessSignupStarted = 'cardless_signup_started',
  CardlessSignupCompleted = 'cardless_signup_completed',
}
